export enum DocumentTypeEnum {
  Invoice = 1,
  Document = 2,
  Report = 3,
}
